var map = {
	"./cuarto-poder.json": 62,
	"./de-visita.json": 63,
	"./el-chico.json": 64,
	"./el-cocinero.json": 65,
	"./el-elemental.json": 66,
	"./el-heroe.json": 67,
	"./el-sueño.json": 68,
	"./fragmentos-de-vida.json": 69,
	"./index.json": 10,
	"./la-chica-de-la-parada.json": 70,
	"./la-ejecucion.json": 71,
	"./la-escultora.json": 72,
	"./la-presencia.json": 73,
	"./microrelatos.json": 74,
	"./nervo.json": 75,
	"./patentes-y-ruedas.json": 76,
	"./tags.json": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 200;